import { render, staticRenderFns } from "./DealComponent.vue?vue&type=template&id=4f665c94&scoped=true&"
import script from "./DealComponent.vue?vue&type=script&lang=js&"
export * from "./DealComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f665c94",
  null
  
)

export default component.exports